import isMobile from './is-mobile.js';
import '../../plugins/jquery.easing.min.js';

$(".js-accordion-button").on("click", function(){
  $(this).closest(".js-accordion").toggleClass("js-accordion-open");
  $(this).next(".js-accordion-content").stop().slideToggle(200, "easeOutQuad");
  // $(this).next(".js-accordion-content").css({
  //   height: $(this).next(".js-accordion-content").outerHeight(true)
  // });
})
